import React, { useState } from 'react';

export default function CaseList({ cases, onCaseClick }) {
    const [sortBy, setSortBy] = useState('priority');

    const sortedCases = [...cases].sort((a, b) => {
        if (sortBy === 'priority') return b.priorityScore - a.priorityScore;
        if (sortBy === 'age') return b.daysOverdue - a.daysOverdue;
        if (sortBy === 'amount') return b.amountOwed - a.amountOwed;
        return 0;
    });

    return (
        <div className="case-list">
            <h2>📋 All Cases</h2>

            <div className="controls">
                <label>Sort by:</label>
                <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                    <option value="priority">Priority Score ⬇️</option>
                    <option value="age">Days Overdue ⬇️</option>
                    <option value="amount">Amount Owed ⬇️</option>
                </select>
            </div>

            <table className="cases-table">
                <thead>
                    <tr>
                        <th>Case ID</th>
                        <th>Customer</th>
                        <th>Amount Owed</th>
                        <th>Days Overdue</th>
                        <th>Priority</th>
                        <th>Status</th>
                        <th>Assigned DCA</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedCases.map((c) => (
                        <tr
                            key={c.id}
                            className={`priority-${c.priorityScore > 7 ? 'high' : 'medium'}`}
                        >
                            <td>
                                <strong>#{c.id}</strong>
                            </td>
                            <td>{c.customerName}</td>
                            <td>${c.amountOwed.toLocaleString()}</td>
                            <td>{c.daysOverdue} days</td>
                            <td>
                                <span
                                    className={`priority-badge priority-${c.priorityScore > 7 ? 'high' : 'medium'
                                        }`}
                                >
                                    {c.priorityScore.toFixed(1)}
                                </span>
                            </td>
                            <td>
                                <span
                                    className={`status-badge ${c.status
                                        .toLowerCase()
                                        .replace(' ', '-')}`}
                                >
                                    {c.status}
                                </span>
                            </td>
                            <td>{c.assignedDCA}</td>
                            <td>
                                <button
                                    onClick={() => onCaseClick(c.id)}
                                    className="view-btn"
                                >
                                    View
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

